import { TableV2ToneChip } from '@/features/shared/components/tableSystem/TableV2Primitives';
import { formatUploadStatusLabel, getUploadStatusChipColor } from '@/features/uploads/formatters';
import type { UiTone } from '@/theme/uiTokens';
import type { UploadDto } from '@flowqa/shared';
import type { ReactElement } from 'react';

const resolveUploadStatusTone = (status: UploadDto['status']): UiTone => {
  const statusColor = getUploadStatusChipColor(status);
  if (statusColor === 'grey') return 'neutral';
  if (statusColor === 'yellow') return 'orange';
  return statusColor;
};

export const UploadStatusChip = ({ status }: { status: UploadDto['status'] }): ReactElement => {
  return (
    <TableV2ToneChip
      label={formatUploadStatusLabel(status)}
      tone={resolveUploadStatusTone(status)}
    />
  );
};
